var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "marker-container d-flex flex-column h-100" },
    [
      _c("div", { staticClass: "p-2 border-bottom" }, [
        _c("div", { staticClass: "input-group input-group-sm" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.state.filterText,
                expression: "state.filterText"
              }
            ],
            staticClass: "form-control border-left-0",
            attrs: { type: "text", placeholder: _vm.$t("txtSearch") + "..." },
            domProps: { value: _vm.state.filterText },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.state, "filterText", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.state.filterText
            ? _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-secondary border-left-0 bg-white",
                    on: {
                      click: function($event) {
                        _vm.state.filterText = ""
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-control custom-checkbox mt-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.state.onlyIssues,
                expression: "state.onlyIssues"
              }
            ],
            staticClass: "custom-control-input",
            attrs: { type: "checkbox", id: "issueOnly" },
            domProps: {
              checked: Array.isArray(_vm.state.onlyIssues)
                ? _vm._i(_vm.state.onlyIssues, null) > -1
                : _vm.state.onlyIssues
            },
            on: {
              change: function($event) {
                var $$a = _vm.state.onlyIssues,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.state, "onlyIssues", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.state,
                        "onlyIssues",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.state, "onlyIssues", $$c)
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom-control-label small",
              attrs: { for: "issueOnly" }
            },
            [_vm._v(_vm._s(_vm.$t("maintenance.overview2d.issueMarkers")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-grow-1",
          staticStyle: {
            "overflow-y": "scroll",
            "min-height": "0",
            height: "0"
          }
        },
        [
          _vm.rows.length === 0
            ? _c("div", { staticClass: "p-4 text-center text-muted small" }, [
                _c("i", {
                  staticClass: "fa fa-filter mb-2 d-block",
                  staticStyle: { "font-size": "1.5rem" }
                }),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.state.filterText
                        ? _vm.$t("general.noData")
                        : _vm.$t("maintenance.overview2d.noMarkers")
                    ) +
                    "\n\t\t"
                )
              ])
            : _c(
                "ul",
                { staticClass: "list-group list-group-flush" },
                _vm._l(_vm.rows, function({ marker, cell, activities }) {
                  return _c(
                    "li",
                    {
                      key: marker.id,
                      ref: _vm.setMarkerRowRef(marker.id),
                      refInFor: true,
                      staticClass:
                        "list-group-item d-flex align-items-start c-pointer transition-all",
                      class: {
                        "active-marker":
                          marker.id === _vm.state.selectedMarkerId
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectMarker(marker.id)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "mr-3 mt-1" }, [
                        _c("span", {
                          staticClass: "status-dot",
                          style: {
                            background: _vm.getMarkerColor(
                              marker,
                              _vm.state.activityStore
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-grow-1 overflow-hidden" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center mb-1"
                            },
                            [
                              _c("b", { staticClass: "text-truncate" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      marker.label ||
                                        "(" + _vm.$t("general.unnamed") + ")"
                                    ) +
                                    " "
                                )
                              ]),
                              _vm._v(" "),
                              activities.length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-danger text-uppercase px-2",
                                      staticStyle: { "font-size": "0.65rem" }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "maintenance.overview2d.issueMarkers"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "details-grid" }, [
                            marker.category
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-muted extra-small d-flex align-items-center mb-1 font-weight-bold"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-tags mr-1 text-secondary"
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(marker.category))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            cell
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-muted extra-small d-flex align-items-center mb-1"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-cube mr-1 text-secondary"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "link-styled",
                                        attrs: {
                                          href: "quick?cell=" + cell.id,
                                          target: "_blank"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t    " +
                                            _vm._s(cell.name) +
                                            " \n\t\t\t\t\t  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    cell.label
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-inline-flex align-items-center ml-2 text-muted"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-tag mr-1 text-secondary"
                                            }),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(cell.label) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            activities.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-muted extra-small d-flex align-items-center"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle mr-1 text-secondary"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "link-styled",
                                        attrs: {
                                          href:
                                            "quick/activity?Act=" +
                                            activities[0].id,
                                          target: "_blank"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(activities[0].title) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          marker.id === _vm.state.selectedMarkerId
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-2 pt-2 border-top extra-small text-muted font-italic"
                                },
                                [
                                  cell && cell.ident
                                    ? _c("span", [
                                        _vm._v(
                                          "\n\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t(
                                                "maintenance.overview2d.marker.model.cellId"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(cell.ident) +
                                            " | " +
                                            _vm._s(
                                              _vm.formatDateTime(cell.updatedAt)
                                            ) +
                                            " |\n\t\t\t\t\t"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n\t\t\t\t\tx: " +
                                      _vm._s(marker.nx.toFixed(3)) +
                                      ", y: " +
                                      _vm._s(marker.ny.toFixed(3)) +
                                      "            \n\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-2 d-flex flex-column" }, [
                        marker.id === _vm.state.selectedMarkerId
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-link btn-sm p-0 text-danger opacity-7",
                                attrs: {
                                  type: "button",
                                  title: _vm.$t("general.delete")
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.removeMarker(marker.id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash-alt" })]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                0
              )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text bg-white border-right-0" }, [
        _c("i", { staticClass: "fa fa-search text-muted" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }